export default __webpack_public_path__ + "static/media/IBHipExtensionTerminalSwing.15882fdf.png";